module.exports = __webpack_public_path__ + "img/logo2.92c7165a.png";